import EpgEvent from '../../../classes/epgEvent';
import RegularEvent from '../../../classes/regularEvent';
import { store } from '../../../store/store';
import { updateEvents as updateEventsAction } from '../../../store/thunks/events.thunk';
import { useAppDispatch } from '../../../store/hooks';
import { useEffect, useRef } from 'react';

function useUpdateEvents({
  data: ogData,
  changeDescription,
  filter,
}: {
  data: (EpgEvent | RegularEvent | undefined)[];
  changeDescription?: () => void;
  filter: string;
}) {
  const dispatch = useAppDispatch();
  const dataRef = useRef(ogData);

  // Actions

  const updateEvents = () => {
    dispatch(updateEventsAction(true));
    if (!dataRef.current.length) return;
    const { events } = store.getState();
    const newData = dataRef.current.map((item) => {
      if (item && item.channel)
        return (
          events.currentEvents[item.channel.id] ||
          events.mockedEvents[item.channel.id]
        );
      return item;
    });
    if (changeDescription) changeDescription();
    dataRef.current = newData;
  };

  // Effect hooks

  useEffect(() => {
    dataRef.current = ogData;
    updateEvents();
  }, [ogData.length, filter]);

  return dataRef.current as EpgEvent[];
}

export default useUpdateEvents;
